module.exports = __webpack_public_path__ + "img/gas.539f93aa.svg";